import $ from 'jquery';
import DealerSearchModal from 'features/ctas/dealer.search.modal';
import zip from 'lib/util/zip';
import tdaConfig from 'lib/util/tda.config';
import cookies from 'utils/cookies';

// This file is for TDAs using LivePerson as the chat provider
//
// The global Unified Markup tag is currently in fixed-layout.page.xsl and deployed
// via LSDS, as per LivePerson, this tag must be in the head element of every page
//
// If a TDA is using LivePerson is configured in tda_config.xml
// BATSiteConfig.isLivePerson

var __isWWW = tdaConfig.tda.code === 'WWW';

var livePersonCta = {
  initChat: function (e, selectedDealer) {
    e.preventDefault();
    window.lpTag.sdk.exec('caoEngager.startChat', {
      referenceId: String(selectedDealer),
      engagementId: 1,
      language: 'en-US',
      channel: 'chat'
    });
  }
};

Object.setPrototypeOf(livePersonCta, DealerSearchModal);

export default {

  // refereceId is the dealercode
  dealerChat: function (referenceId, engagementId) {
    // at the moment, it looks like es-US is not supported
    // var chatLang = langFromUrl() === 'en' ? 'en-US' : 'es-US';
    var $liveChatLivePerson = $("a[data-destination='live-chat-liveperson'][data-dealercode='" + referenceId + "']");
    var chatEngConfiguration = {
      referenceId: referenceId,
      engagementId: engagementId,
      language: 'en-US',
      channel: 'chat'
    };

    $liveChatLivePerson.on('click', function (e) {
      var directDealerCode = $(this).data('dealercode');
      var __type = 'live-chat-liveperson';
      if (directDealerCode) {
        e.preventDefault();
        window.lpTag.sdk.exec('caoEngager.startChat', chatEngConfiguration);
      } else if (__isWWW || cookies.getItem('isConfirmedZip') !== 'true') {
        livePersonCta.enterZip(__type);
        return false;
      } else {
        e.preventDefault();
        livePersonCta.beginSearch(zip.getCookiedDefaultFallback(), __type);
        return false;
      }
      return false;
    });

    function presenceCallback(presenceData) {
      // console.log('presenceData.presenceStatus', presenceData.presenceStatus);
      if (presenceData.presenceStatus === 'online') {
        // do something here?
        // console.log('%c Online', 'background: blue; color: white'); // eslint-disable-line no-console
      } else {
        // 'No agents are currently available for live chat';
        console.log('%c No agents available', 'background: red; color: white'); // eslint-disable-line no-console
      }
    }

    function presenceErrorCallback() {
      console.log('Error checking presence'); // eslint-disable-line no-console
    }

    var presenceReq = {
      referenceId: referenceId,
      engagementId: engagementId,
      onSuccess: presenceCallback,
      onError: presenceErrorCallback
    };

    window.lpTag.sdk.exec('caoPresence.getPresence', presenceReq);
  }
};
